
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { academyStore, mainStore } from '@/store';
import ShowPopup from '@/components/ShowPopup.vue';
import Create from './Create.vue';
import _, { random } from 'lodash';
import { userToolStore } from '../../../utils/store-accessor';

@Component({
  components: {
    ShowPopup,
    Create,
  },
})
export default class ListTable extends Vue {
  @Watch('propState', { immediate: true, deep: true })
  async buscaInfo() {
    if (this.propState > 0) {
      this.isLoading = true;
      this.academy_videos = await academyStore.getAcademy();
      this.isLoading = false;
    }
  }
  public isLoading = false;
  public academyId = 0;
  public propState = 0;
  public academy_videos = [];

  public headerAcademy = [
    {
      text: 'SrcVimeo (Vídeo)',
      sortable: true,
      value: 'srcvideo',
      align: 'left',
    },
    {
      text: 'SrcImg (Imagem)',
      sortable: true,
      value: 'srcimg',
      align: 'left',
    },
    {
      text: 'Título',
      sortable: true,
      value: 'title',
      align: 'left',
    },
    {
      text: 'Descrição',
      sortable: true,
      value: 'description',
      align: 'left',
    },
    {
      text: 'Categoria',
      sortable: true,
      value: 'category',
      align: 'left',
    },
    {
      text: 'Ordem Exibição',
      sortable: true,
      value: 'ordem',
      align: 'left',
    },
    {
      text: 'Funções',
      sortable: true,
      value: 'roles',
      align: 'left',
    },
    {
      text: 'Ações',
      sortable: true,
      value: 'actions',
      align: 'left',
    },
  ];

  get currentUser() {
    return mainStore.userProfile;
  }

  get userTool() {
    return userToolStore.currentUserTools.find((t) => t.tool_id === 69);
  }

  public handleEditVideo(item) {
    this.academyId = item.id;
    this.propState = 0;
    let form: any = this.$refs.showVideos;
    form.show();
  }

  public async handleDeleteVideo(item) {
    await this.$swal({
      title: 'Remover item?',
      icon: 'warning',
      html: `Tem certeza que deseja excluir o vídeo?<br>`,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await academyStore.deleteAcademy(item.id);
      }
    });
    this.academy_videos = await academyStore.getAcademy();
  }

  public handleCreateVideo() {
    let aux = String(Math.floor(Math.random() * 100000));
    this.academyId = Number(aux.padEnd(8, '0'));
    this.propState = 0;
    let form: any = this.$refs.showVideos;
    form.show();
  }

  public async mounted() {
    this.isLoading = true;

    this.academy_videos = await academyStore.getAcademy();

    this.isLoading = false;
  }
}
